module.exports = __webpack_public_path__ + "img/sessionMap1.13975a0a.png";